<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h2>دسته بندی های پرداخت</h2>

            <router-link class="btn btn-primary ml-auto" to="/dashboard/PaymentSegment">ساخت دسته جدید</router-link>
            <div class="table-responsive mt-4">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>نام دسته</th>
                    <th>وضعیت</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="segment in segments" :key="segment._id">
                    <td>{{ segment.title }}</td>
                    <td>
                      <button class="btn btn-danger mr-4" @click="removeSegment(segment)">حذف</button>
                      <router-link :to="{ path: '/dashboard/PaymentSegment', query: { id: segment._id } }"
                        >مشاهده</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentSegmentService from '../../../../services/paymentSegmentService';
export default {
  name: 'segments',
  data() {
    return {
      segments: [],
    };
  },
  created() {
    this.getSegments();
  },
  methods: {
    async removeSegment(group) {
      try {
        await paymentSegmentService.deleteSegment(group._id);
        window.notif({ mssg: 'سگمنت با موفقیت حذف شد', isError: false });
        this.getSegments();
      } catch (err) {
        console.log(err);
        window.notif({ mssg: 'مشکلی پیش آمده', isError: true });
      }
    },

    async getSegments() {
      try {
        const resData = await paymentSegmentService.getSegments({});
        this.segments = resData;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
